/* 
Filters.

For flexibility and easier unit testing, most formatting is done by the format helper and the
filters just call the corresponding formatting function.
*/
import * as formatting from "@/helpers/formatting.helper";

export default {
  filters: {
    notSpecified: function(value) {
      return value || "Not specified";
    },
    compactDate: function(dateAsString) {
      return formatting.compactDate(dateAsString);
    },
    compactDateTime: function(dateAsString) {
      return formatting.compactDateTime(dateAsString);
    },
    squishedDateTime: function(dateAsString) {
      return formatting.squishedDateTime(dateAsString);
    },
    friendlyDateTime: function(dateAsString) {
      return formatting.friendlyDateTime(dateAsString);
    },
    longDate: function(dateAsString) {
      return formatting.longDate(dateAsString);
    },
    longDateTime: function(dateAsString) {
      return formatting.longDateTime(dateAsString);
    },
    timespan: function(timespanAsString) {
      return formatting.timespan(timespanAsString);
    },
    yesNo: function(boolean) {
      return formatting.yesNo(boolean);
    },
    number: function(numericValue) {
      return formatting.formatNumber(numericValue);
    },
    currency: function(dollarValue) {
      return formatting.currency(dollarValue);
    },
    currency0: function(dollarValue) {
      return formatting.currency0(dollarValue);
    },
    percentage: function(percentValue) {
      return formatting.percentage(percentValue);
    },
    percentage0: function(percentValue) {
      return formatting.percentage(percentValue, 0);
    },
    percentage1: function(percentValue) {
      return formatting.percentage(percentValue, 1);
    },
    percentage2: function(percentValue) {
      return formatting.percentage(percentValue, 2);
    },
    percentage3: function(percentValue) {
      return formatting.percentage(percentValue, 3);
    },
    numericInput1: function(value) {
      return formatting.numericInput1(value);
    },
    numericInput2: function(value) {
      return formatting.numericInput2(value);
    },
    numericInput3: function(value) {
      return formatting.numericInput3(value);
    },
    bracketed: function(s) {
      return s ? `(${s})` : "";
    },
    explanation: function(s) {
      return formatting.explanation(s);
    },
    startWithLowerCase: function(s) {
      return formatting.startWithLowerCase(s);
    },
    fullStop: function(s) {
      return formatting.fullStop(s);
    },
    stripRequiredIndicator: function(label) {
      return formatting.stripRequiredIndicator(label);
    },
    exceptionLogColour(level) {
      if (level == "Info") {
        return "green--text";
      } else if (level == "Error" || level == "Fatal") {
        return "red--text font-weight-bold";
      } else if (level == "Warn") {
        return "orange--text";
      } else {
        return "";
      }
    },
    ordinal(value) {
      if (value <= 0) return `${value}`;
      if (value >= 11 && value <= 13) return `${value}th`;
      if (value % 10 == 1) return `${value}st`;
      if (value % 10 === 2) return `${value}nd`;
      if (value % 10 === 3) return `${value}rd`;
      return `${value}th`;
    }
  }
};
